import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { cardStyle, btnStyle, colors } from "./lib/theme";
import { formatDayTime } from "./lib/weekUtils";

export default function SessionsInfoPage() {
  var [venues, setVenues] = useState([]);
  var [templates, setTemplates] = useState([]);

  useEffect(function () {
    var unsubVenues = onSnapshot(query(collection(db, "venues"), orderBy("name")), function (snap) {
      setVenues(snap.docs.map(function (d) { return { id: d.id, ...d.data() }; }));
    });
    var unsubTpl = onSnapshot(collection(db, "sessionTemplates"), function (snap) {
      setTemplates(snap.docs.map(function (d) { return { id: d.id, ...d.data() }; }).filter(function (t) { return t.active; }));
    });
    return function () { unsubVenues(); unsubTpl(); };
  }, []);

  var venuesWithSessions = venues
    .map(function (v) {
      var sessions = templates
        .filter(function (t) { return t.venueId === v.id; })
        .sort(function (a, b) { return a.dayOfWeek - b.dayOfWeek; });
      return { venue: v, sessions: sessions };
    })
    .filter(function (v) { return v.sessions.length > 0; });

  return (
    <div>
      <h2 style={{ fontSize: 18, marginBottom: 4 }}>East Anglia Pickleball Sessions</h2>
      <p style={{ fontSize: 13, color: colors.textDim, marginTop: 0, marginBottom: 20 }}>
        Where and when we play.
      </p>

      {venuesWithSessions.length === 0 && (
        <div style={{ ...cardStyle, marginBottom: 14 }}>
          <p style={{ margin: 0, fontSize: 14, color: colors.textDim }}>No sessions have been set up yet — check back soon.</p>
        </div>
      )}

      {venuesWithSessions.map(function (vs) {
        var v = vs.venue;
        return (
          <div key={v.id} style={{ ...cardStyle, marginBottom: 14 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700 }}>{v.name}</div>
                {v.address && <div style={{ fontSize: 12, color: colors.textDim }}>{v.address}</div>}
              </div>
              <div style={{
                fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5,
                padding: "4px 8px", borderRadius: 6,
                background: v.indoor ? colors.limeTint : colors.tealTint,
                color: v.indoor ? colors.accent2 : colors.accent,
                whiteSpace: "nowrap",
              }}>
                {(v.courtCount || 1)} court{(v.courtCount || 1) === 1 ? "" : "s"}{v.indoor ? " · indoor" : ""}
              </div>
            </div>
            {vs.sessions.map(function (t, i) {
              return (
                <div key={t.id} style={{ padding: "8px 0", borderTop: i === 0 ? "1px solid " + colors.border : "none" }}>
                  <div style={{ fontSize: 14, fontWeight: 600 }}>{formatDayTime(t.dayOfWeek, t.time, t.endTime)}</div>
                  {t.note && <div style={{ fontSize: 12, color: colors.textDim }}>{t.note}</div>}
                </div>
              );
            })}
          </div>
        );
      })}

      <div style={{ ...cardStyle, marginBottom: 14 }}>
        <h3 style={{ marginTop: 0, fontSize: 15 }}>Stay in the Loop</h3>
        <p style={{ fontSize: 13, color: colors.text, margin: 0 }}>
          We use an optional members only WhatsApp group to coordinate news and events — it's also just a nice way
          to stay connected with the community. Ask any other member to add you to the group.
        </p>
      </div>

      <div style={cardStyle}>
        <h3 style={{ marginTop: 0, fontSize: 15 }}>Membership</h3>
        <div style={{ display: "flex", gap: 14, marginBottom: 14 }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: colors.accent }}>£15<span style={{ fontSize: 12, fontWeight: 500, color: colors.textDim }}>/month</span></div>
            <div style={{ fontSize: 12, color: colors.textDim }}>Individual</div>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: colors.accent }}>£25<span style={{ fontSize: 12, fontWeight: 500, color: colors.textDim }}>/month</span></div>
            <div style={{ fontSize: 12, color: colors.textDim }}>Couple</div>
          </div>
        </div>
        <p style={{ fontSize: 13, color: colors.text, marginTop: 0 }}>
          Sign up via the LTA / Rickinghall Tennis Club website. Membership covers all the sessions above,
          plus free court booking at Rickinghall any time for pickleball or tennis.
        </p>
        <div style={{ display: "flex", gap: 10 }}>
          <a
            href="https://clubspark.lta.org.uk/rickinghalltennisclub/Membership/JoinAdult?id=32f53281-6b44-47df-bf87-6c3e61c4500d"
            target="_blank" rel="noopener noreferrer"
            style={{ ...btnStyle, textDecoration: "none", textAlign: "center", display: "block", flex: 1 }}
          >
            Individual
          </a>
          <a
            href="https://clubspark.lta.org.uk/rickinghalltennisclub/Membership/JoinGroup?id=b78409d0-deab-46eb-9b95-751ab63c6290"
            target="_blank" rel="noopener noreferrer"
            style={{ ...btnStyle, textDecoration: "none", textAlign: "center", display: "block", flex: 1 }}
          >
            Couple
          </a>
        </div>
      </div>

      <p style={{ fontSize: 12, color: colors.textDim, marginTop: 16 }}>
        Know a venue we should try? Let us know and we'll consider it.
      </p>
    </div>
  );
}
